import React from 'react'
import { Info } from 'react-feather'

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

const CompassGlobalLinkTooltip: React.FC = () => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Info
          className="text-primary"
          size="15px"
          style={{ marginLeft: '5px' }}
        />
      </TooltipTrigger>

      <TooltipContent>
        Your global link is a unique link for your firm's Compass portal for
        clients. Simply copy the link, share it with clients - they'll then be
        able to complete Compass or create an account. For maximum impact, we
        recommend using this link as part of your client onboarding process or
        during your annual review cycle.
      </TooltipContent>
    </Tooltip>
  )
}

export default CompassGlobalLinkTooltip
